import React, { useState, useEffect } from "react";
import ItemSelectInput from "./ItemSelectInput.tsx"; // 根据实际路径调整
import {
  FormDataConsumer,
  SimpleForm,
  TextField,
  TextInput,
  useDataProvider,

} from 'react-admin';
import { useNavigate, useParams } from 'react-router-dom';

import { useNotify, useRedirect, useRefresh } from 'react-admin';

const CalculateForm = () => {
  const [product, setProduct] = useState(""); // 选择的产品
  const [result, setResult] = useState({ blend: 0, cans: 0 }); // 计算结果
  const [rawMaterials, setRawMaterials] = useState<any[]>([]);
  const [finishedGoods, setFinishedGoods] = useState<any[]>([]);
  const [materialStock, setMaterialStock] = useState<string>("");
  const [blendSize, setBlendSize] = useState<string>("");
  const [size, setSize] = useState<string>("");
  const [bomQuantity, setBomQuantity] = useState<string>("");
  const notify = useNotify();
  const [selectedMaterial, setSelectedMaterial] = useState<any>(null); // 存储选中的物料

  const dataProvider = useDataProvider();
  // 统一请求 FinishedGood 产品

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5180/api';

  useEffect(() => {
    setLoading(true);

    // 并行请求 FinishedGood 和 RawMaterial（假设接口都能用getList和filter）
    Promise.all([
      // dataProvider.getList('bom/getFinishedGoodsSelectInput', {
      //   pagination: { page: 1, perPage: 10000 },
      //   sort: { field: 'productId', order: 'ASC' },
      //   filter: { type: 'FinishedGood' },
      // }),
      dataProvider.getList('bom/getFinishedGoodsSelectInput', {
        pagination: { page: 1, perPage: 10000 },
        sort: { field: 'productId', order: 'ASC' },
        filter: { type: 'RawMaterial' },
      }),

    ])
      .then(([rawMaterialsRes]) => {

        setRawMaterials(rawMaterialsRes.data);
        // setFinishedGoods(finishedGoodsRes.data);

        setLoading(false);
      })
      .catch(e => {
        setError(e);
        setLoading(false);
      });
  }, [dataProvider, API_URL]);

  // 获取物料库存的函数
  const fetchMaterialStock = async (materialId: string) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}/Stock/getStock/${materialId}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`, // 传递 token
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch material stock");
      }

      const data = await response.json();
      setMaterialStock(data.stockQuantity); // 假设返回的数据中有 `stock` 字段
      setFinishedGoods(data.materialBomInfos || []); // 设置产品选项 
      // console.log("Fetched material stock:", materialStock);
    } catch (error) {
      console.error("Failed to fetch material stock:", error);
      setMaterialStock("");
    }
  };

  if (loading) return <span>Loading...</span>;
  if (error) return <span>Error loading product options</span>;

  // 计算逻辑
  const calculate = () => {
    // 检查 Material 是否选中
    if (!selectedMaterial) {
      alert("请确保选择了物料！");
      return;
    }

    // 检查 Material Stock 是否有效
    if (!materialStock || isNaN(Number(materialStock)) || Number(materialStock) <= 0) {
      alert("请确保输入有效的库存值！");
      return;
    }

    // 检查 Blend Size 是否有效
    if (!blendSize || isNaN(Number(blendSize)) || Number(blendSize) <= 0) {
      alert("请确保输入有效的 Product！");
      return;
    }
    // 示例计算逻辑（根据实际需求替换）
    const blend = Math.floor(Number(materialStock) / Number(bomQuantity)); // 向下取整
    const cans = blend * Math.floor((Number(blendSize) / Number(size))); // 根据产品尺寸计算罐数

    setResult({ blend, cans });
  };

  return (
    <div className="container mt-4">

      <SimpleForm toolbar={false}>
        <div style={{ display: "flex", gap: "16px", width: "100%" }}>
          {/* 左边：选择物料 */}
          <div style={{ flex: 1 }}>
            <label htmlFor="material" className="form-label">
              Select Material:
            </label>
            <ItemSelectInput
              showSearch
              source="material"
              choices={rawMaterials}
              onChange={(value) => {
                console.log("Selected value:", value.name);
                setSelectedMaterial(value); // 存储选中的物料

                fetchMaterialStock(value.productId); // 调用接口获取库存
              }}
              sx={{
                "& .MuiAutocomplete-inputRoot": {
                  minHeight: 50,
                  width: "100%",
                  height: 50,
                  alignItems: "center",
                },
                "& .MuiInputBase-root": {
                  minHeight: 50,
                  height: 50,
                  alignItems: "center",
                },
              }}
            />
          </div>

          {/* 右边：库存数量 */}
          <div style={{ flex: 1 }}>
            <label htmlFor="quantity" className="form-label">
              Stock Quantity:
            </label>
            <input
              type="text"
              value={materialStock}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "") {
                  setMaterialStock("");
                  return;
                }
                if (!/^\d*\.?\d*$/.test(value)) {
                  notify("请输入有效数字", { type: "warning" });
                } else {
                  setMaterialStock(value);
                }
              }}
              onBlur={() => {
                if (materialStock !== "" && !isNaN(Number(materialStock))) {
                  setMaterialStock(Number(materialStock).toFixed(2));
                }
              }}
              className="form-control "
              style={{ height: 50, marginTop: '8px' }}
            />
          </div>
        </div>

        <div style={{ width: '100%' }}>
          <label htmlFor="product" className="form-label">
            Select Product:
          </label>
          <ItemSelectInput
            showSearch
            source="productId"
            choices={finishedGoods}
            onChange={(value) => {
              console.log("Selected value:", value.name);
              console.log("Selected blendSize:", value.blendSize);
              console.log("Selected bomQuantiy:", value.bomQuantity);
              console.log("Selected Size:", value.size);
              setBlendSize(value.blendSize);
              setBomQuantity(value.bomQuantity);
              setSize(value.size);
            }}
            sx={{
              '& .MuiAutocomplete-inputRoot': {
                minHeight: 50, // 你想要的高度
                width: '100%',
                height: 50,
                alignItems: 'center',
              },
              // 兼容 SelectInput
              '& .MuiInputBase-root': {
                minHeight: 50,
                height: 50,
                alignItems: 'center',
              },
            }}
          />
          <div className="d-flex align-items-center mb-3" style={{ gap: '16px' }}>
            <div style={{ flex: 1 }}>
              <label htmlFor="blendSize" className="form-label">
                Blend Size (kg):
              </label>
              <input
                type="text"
                readOnly
                value={blendSize}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "") {
                    setBlendSize("");
                    return;
                  }
                  if (!/^\d*\.?\d*$/.test(value)) {
                    notify("请输入有效数字", { type: "warning" });
                  } else {
                    setBlendSize(value);
                  }
                }}
                onBlur={() => {
                  if (blendSize !== "" && !isNaN(Number(blendSize))) {
                    setBlendSize(Number(blendSize).toFixed(2));
                  }
                }}
                className="form-control"
                style={{ height: 50 }}
              />
            </div>

            <div style={{ flex: 1 }}>
              <label htmlFor="bomQuantity" className="form-label">
                Blend Quantity (kg):
              </label>
              <input
                type="text"
                readOnly
                value={bomQuantity}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "") {
                    setBomQuantity("");
                    return;
                  }
                  if (!/^\d*\.?\d*$/.test(value)) {
                    notify("请输入有效数字", { type: "warning" });
                  } else {
                    setBomQuantity(value);
                  }
                }}
                onBlur={() => {
                  if (bomQuantity !== "" && !isNaN(Number(bomQuantity))) {
                    setBomQuantity(Number(bomQuantity).toFixed(2));
                  }
                }}
                className="form-control"
                style={{ height: 50 }}
              />
            </div>
          </div>

        </div>
        <button
          type="button"
          className="btn btn-primary"
          onClick={calculate}
        >
          Calculate
        </button>
      </SimpleForm>
      <div className="" style={{ marginLeft: '15px' }}>
        <h2>result：</h2>
        <p>
          Blend quantity: <strong>{result.blend}</strong>,<span style={{ marginRight: "16px" }}></span> Can quantity: <strong>{result.cans}</strong>
        </p>
      </div>
    </div>
  );
};

export default CalculateForm;